import { format, isValid } from 'date-fns';

const dateFormat = 'dd.MM.yyyy';

const formatDateToString = (
    date: Date,
    fallbackValue?: string
): string | undefined => {
    if (isValid(date)) {
        return format(date, dateFormat);
    } else {
        return fallbackValue;
    }
};

export { dateFormat, formatDateToString };
